import React, { useState } from 'react';
import Logo from './Logo';
import MenuLinks from './MenuLinks';
import PhoneSection from './PhoneSection';
import AuthButtons from './AuthButtons';
import BurgerMenu from './BurgerMenu';
import UserMenu from './User';

const NavBar = (props) => {
 
    return (
        <div className={`mainBlock__top p-5 transition-all ${props.isScrolled ? 'fixed top-0 left-0 w-full shadow-lg z-50' : 'relative'}`}>
            <div className="flex justify-between items-center w-full">
                <div className="mainBlock__top-menu flex items-center gap-[49px]">
                    <Logo logo={props.logo} />
                    <div className="hidden xl:flex">
                        <MenuLinks data={props.data} color={props.color}/>
                    </div>
                </div>
                <div className="mainBlock__top-buttons flex items-center">
                    <div className="hidden lg:flex items-center">
                        <PhoneSection data={props.data} color={props.color}/>
                        {
                            !props.authorized ? (
                                <AuthButtons data={props.data} color={props.color}/>
                            ) : <UserMenu data={props.data}/>
                        }
                    </div>
                    <div className="flex items-center xl:hidden"> 
                        <BurgerMenu onClick={props.toggleMenu}
                        BurgerBtnImg={props.burger.img} burgerColor={'#EFF0F2'}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default NavBar;
